import { defineComponent as _defineComponent } from 'vue'
import { useDogspace } from '@/store/dogspaces';
import { useScheduleRequests } from '@/store/useScheduleRequests';
import { Dogspaces, Events, ScheduleRequest } from '@busy-human/k9-library';
import { computed, onMounted, ref } from 'vue';
import UpdateRequest from './update-request.vue';
import UndoIcon from '@/resources/icons/icons8_undo.png';


export default /*@__PURE__*/_defineComponent({
  __name: 'pending-requests',
  setup(__props, { expose: __expose }) {
  __expose();

const requestStore = useScheduleRequests();
const dogStore = useDogspace();

const selectedRequest = ref<string | null>(null);

const signedRequests = computed(() => 
	requestStore.pendingRequests.filter((r) => !(r.eventType === Events.EventType.Training && r.agreementId && !r.agreementSigned))
);


function getEventColor(event: ScheduleRequest.Model) {
	if(event.eventType === Events.EventType.Training) {
		return "#ADE6FF";
	} else if (event.eventType === Events.EventType.Boarding) {
		return "#DBFFBF";
	} else if (event.eventType === Events.EventType.PickupDropoff) {
		return "#D7D7D7";
	}
}

function getSizeColor(dog: Dogspaces.Model) {
	if(dog?.size === 'small') return "#A4E4FF";
	else if(dog?.size === 'medium') return "#AC97FF";
	else if(dog?.size === 'large') return "#E497FF";
	else if(dog?.size === "x-large") return "#FF9399";
	else return "#D7D7D7";
}

onMounted (() => {
    console.log("REQUESTS:", requestStore);
});

const __returned__ = { requestStore, dogStore, selectedRequest, signedRequests, getEventColor, getSizeColor, get useDogspace() { return useDogspace }, get useScheduleRequests() { return useScheduleRequests }, get Dogspaces() { return Dogspaces }, get Events() { return Events }, get ScheduleRequest() { return ScheduleRequest }, computed, onMounted, ref, UpdateRequest, get UndoIcon() { return UndoIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})